module.exports = __webpack_public_path__ + "mf.svg?d3fbe0d987afbd8149e84ca101791d16";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/mf.svg
// module id = 1235
// module chunks = 0